/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//

import { Html5Qrcode } from 'html5-qrcode';
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
export default {
  name: 'ModalScan',
  components: {
    Popup: Popup
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showMask: {
      type: Boolean,
      default: false
    },
    qrbox: {
      type: Number,
      default: 250
    },
    fps: {
      type: Number,
      default: 10
    },
    scanId: {
      type: String,
      default: 'qr-code-full-region'
    }
  },
  computed: {
    currValue: {
      get: function get() {
        return this.value;
      },
      set: function set(v) {
        this.$emit('input', v);
      }
    },
    config: function config() {
      return {
        focusMode: 'continuous',
        fps: this.fps,
        qrbox: {
          width: this.qrbox,
          height: this.qrbox
        }
      };
    }
  },
  watch: {
    currValue: function currValue(val) {
      var _this = this;
      if (this.currValue) {
        this.startCap();
      } else {
        this.stopScan();
      }
      if (val) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this.currValue = false;
          }
        });
      } else {
        this.$setLeft({
          control: false
        });
      }
    }
  },
  data: function data() {
    return {
      $html5QrcodeScanner: null
    };
  },
  mounted: function mounted() {
    this.init();
  },
  created: function created() {},
  methods: {
    stopScan: function stopScan() {
      if (this.$html5QrcodeScanner) {
        this.$html5QrcodeScanner.stop();
      }
    },
    startCap: function startCap() {
      if (this.$html5QrcodeScanner) {
        this.$html5QrcodeScanner.start({
          facingMode: 'environment'
        }, this.config, this.onScanSuccess, function (e) {
          console.log(e);
        });
      } else {
        console.log('this.$html5QrcodeScanner is null');
      }
    },
    init: function init() {
      this.$html5QrcodeScanner = new Html5Qrcode(this.scanId, this.config);
      // const html5QrcodeScanner = new Html5QrcodeScanner('qr-code-full-region', config)
    },
    onScanSuccess: function onScanSuccess(decodedText, decodedResult) {
      console.log('AutoConsole: onScanSuccess -> decodedText, decodedResult', decodedText, decodedResult);
      this.currValue = false;
      this.$emit('result', decodedText, decodedResult);
    }
  }
};